import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'roadmaps.directions'

export const createRoadmapDirectionsModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "RoadmapDirectionsModal" */
    './components/RoadmapDirectionsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
